import {ImportingDataTypes} from "../../types";
import {PreventionInvalidityCode} from "./shared";
import {MenuItem} from "@mui/material";

const options = [
    {value: "text", label: "Text",},
    {value: "number", label: "Number",},
    {value: "decimal", label: "Decimal",},
    {value: "fraction", label: "Fraction",},
    {value: "currency", label: "Currency/Money",},
    {value: "boolean", label: "True/False",},
    {value: "date", label: "Date",},
    {value: "color", label: "Color",},
]

/**
 * Preventative correction config for product properties import.
 */
export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.productProperties,
    sections: [
        {
            sectionKey: "missingProductPropertyFields",
            sectionTitle: "Missing or Invalid Product Property Fields",
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: "title",
                    label: "Title",
                    type: "input",
                    modifyRow: (row, val) => ({...row, title: val}),
                },
                {
                    key: "type",
                    label: "Type",
                    type: "input",
                    textFieldProps: {
                        select: true,
                        SelectProps: {
                            renderValue: (selected) => {
                                const match = options.find(e => e.value === selected);
                                return match ? match.label : selected;
                            }
                        },
                        children: options.map(e => (
                            <MenuItem key={e.value} value={e.value}>{e.label}</MenuItem>
                        ))
                    },
                    extractValue: (o) => typeof o === "string" ? o : o?.value,
                    modifyRow: (row, val) => ({...row, type: val}),
                },
                {
                    key: "description",
                    label: "Description",
                    type: "input",
                    modifyRow: (row, val) => ({...row, description: val}),
                },
            ],
        },
    ],
};
